import React from 'react';
import { Layout, Icon, Breadcrumb as _Breadcrumb, /* Avatar as _Avatar */ } from 'antd';
import styled from 'styled-components';
import { connect } from 'react-redux';

// import { path } from 'utils/media';

const { Content, Footer } = Layout;

const Breadcrumb = styled(_Breadcrumb)`
  flex: 1;
`;

const Container = styled.div`
  padding: 16px;
`;

const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.white};
  padding: 16px;
`;

// const AvatarContainer = styled.div`
//   display: flex;
//   align-items: center;
//   > p {
//     margin-bottom: 0;
//   }
// `;

// const Avatar = styled(_Avatar)`
//   margin-right: 4px;
// `;

const enhance = connect(
  state => ({
    user: state.user,
    router: state.router,
  })
);

function generateBreadcrumb(location) {
  switch (location.pathname) {
    case '/dashboard':
      return [{ label: 'Dashboard', icon: 'bar-chart' }];
    case '/payment-method':
      return [{ label: 'Payment method', icon: 'form' }];
    case '/booking':
      return [{ label: 'Bookings', icon: 'profile' }];
    case '/insight':
      return [{ label: 'Insight', icon: 'profile' }];
    case '/report':
      return [{ label: 'Report', icon: 'file-text' }];
    default:
      return [];
  }
}

const _Layout = (props) => {
  const { /* user */ router, children } = props;
  const { location } = router;
  const breadcrumb = generateBreadcrumb(location);
  return (
    <Layout>
      <Content style={{ overflow: 'initial' }}>
        {location.pathname !== '/' && (
          <BreadcrumbContainer>
            <Breadcrumb>
              <Breadcrumb.Item><Icon type="home" /></Breadcrumb.Item>
              {
                breadcrumb.map((item, index) => (
                  <Breadcrumb.Item key={index}><Icon type={item.icon} /> {item.label}</Breadcrumb.Item>
                ))
              }
            </Breadcrumb>
            {/* {user.loggedIn && (
              <AvatarContainer>
                <Avatar
                  size="large"
                  src={path(user.avatar_image, 'avatar')}
                  srcSet={`${path(user.avatar_image, 'avatar2X')} 2x`}
                />
                <p>{user.name.first}</p>
              </AvatarContainer>
            )} */}
          </BreadcrumbContainer>
        )}
        <Container>
          {children}
        </Container>
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        TakeMeTour Pte. Ltd. © 2017 - 2019
      </Footer>
    </Layout>
  );
}

export { _Layout as Layout };
export default enhance(_Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/index.js